import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ContentWithCardLoading } from "../../../../components/loading";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import * as accountCampaignPricingEmailValidationActions from "../../store/actions/account_campaign_pricing_email_validation_actions";
import AccountCampaignPricingEmailValidationSidePanel from "./components/account-campaign-pricing-email-validation-side-panel";

const ACCOUNT_CAMPAIGN_PRICING_EMAIL_VALIDATION_ACTIONS = {
  NONE: "NONE",
  EDIT: "EDIT",
};

export default function AccountCampaignPricingEmailValidation() {
  const [selectedPricingWithAction, setSelectedPricingWithAction] = useState({
    action: ACCOUNT_CAMPAIGN_PRICING_EMAIL_VALIDATION_ACTIONS.NONE,
    data: {},
  });
  const accountCampaignPricingEmailValidationList = useSelector((state) => state.accounts.accountCampaignPricingEmailValidation);
  const params = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(accountCampaignPricingEmailValidationActions.getPricingOfAccountEmailValidationCampaignRequest({ id: params.accountId }));
  }, [dispatch, params.accountId]);

  return (
    <>
      {accountCampaignPricingEmailValidationList.loading ? (
        <ContentWithCardLoading />
      ) : accountCampaignPricingEmailValidationList.data.length === 0 ? (
        "No accounts"
      ) : (
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
                { title: "Price Per Email Validation", apiKeyName: "price", fieldInputType: "INPUT" },
                { title: "Additional Price Per Email Validation", apiKeyName: "addOnPrice", fieldInputType: "INPUT" },
                { title: "Final Price Per Email Validation ", apiKeyName: "finalPrice", fieldInputType: "INPUT" },
                { title: "Actions", isAction: true, options: ["edit"] },
              ]}
              data={accountCampaignPricingEmailValidationList.data.map((each) => ({
                ...each,
                finalPrice: ((each.addOnPrice || 0) + (each.price || 0)).toFixed(4)
              }))}
              limit={10}
              pageNo={1}
              count={1}
              // actions
              handleEdit={(data) => setSelectedPricingWithAction({ action: ACCOUNT_CAMPAIGN_PRICING_EMAIL_VALIDATION_ACTIONS.EDIT, data })}
            />
          </div>
        </div>
      )}

      <AccountCampaignPricingEmailValidationSidePanel
        show={selectedPricingWithAction.action === ACCOUNT_CAMPAIGN_PRICING_EMAIL_VALIDATION_ACTIONS.EDIT}
        pricingData={selectedPricingWithAction.data}
        handleClose={() => setSelectedPricingWithAction({ action: ACCOUNT_CAMPAIGN_PRICING_EMAIL_VALIDATION_ACTIONS.NONE, data: {} })}
      />
    </>
  );
}
